module.exports = __webpack_public_path__ + "img/wuhan02.5c2bb53f.png";